module.exports = __webpack_public_path__ + "c28671f1ce7eb14817eb1a8c8ed3e4d7.MP3";